import { useCallback } from "react"
import { RecoilState, useSetRecoilState } from "recoil"

export const useRefresher = (recoilState: RecoilState<number>) => {
  const setter = useSetRecoilState(recoilState)
  const refresher = useCallback(() => setter((n) => n + 1), [setter])
  return refresher
}
